import React from "react";
import { Box } from "@mui/material";
import CustomTextField from "./common/CustomTextField";
import CustomSelect from "./common/CustomSelect";
import { COLORS } from "../assets/theme";

interface CustomEmailComponentProps {
  textFieldLabel?: string;
  textFieldValue: string;
  textFieldPlaceholder: string;
  selectLabel: string;
  selectOptions: { label: string; value: string | number }[];
  selectValue: string | number;
  onTextFieldChange: (value: string) => void;
  onSelectChange?: (value: string | number) => void;
}

const CustomEmailComponent: React.FC<CustomEmailComponentProps> = ({
  textFieldValue,
  textFieldPlaceholder,
  selectLabel,
  selectOptions,
  selectValue,
  onTextFieldChange,
  onSelectChange,
}) => {
  const transformText = (input: string): string => {
    return input
      .replace(/\[([^\]]*)\]/g, (bracket) => {
        let inside = bracket.slice(1, -1).trim();
        if (!inside) return "[]";
        let items = inside
          .split(",")
          .map((item) => item.trim().replace(/^['"]|['"]$/g, ""))
          .filter((item) => item !== "");
        // Join as ][
        return items.map((item) => `[${item}]`).join("");
      })
      .replace(/\s{2,}/g, " ");
  };

  const handleSelectChange = (value: string | number | (string | number)[]) => {
    onSelectChange?.(value.toString());

    let prefix = textFieldValue;
    let bracket = "[]";

    const match = prefix.match(/^(.*?)(\s*(\[.*\]))?$/);
    if (match) {
      prefix = match[1] || "";
      if (match[3]) {
        bracket = match[3];
      }
    }

    let inside = bracket.slice(1, -1).trim(); // remove [ ]
    let items = inside ? inside.split(",").map((x) => x.trim()) : [];
    items.push(value.toString().replace(/^['"]|['"]$/g, "")); // strip quotes
    items = items.filter((item) => item !== "");

    let newBracket = `[${items.join(", ")}]`;

    let combined = newBracket === "[]" ? prefix : prefix + " " + newBracket;
    onTextFieldChange(transformText(combined));
  };
  const handleTextFieldChange = (value: string) => {
    onTextFieldChange(transformText(value));
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      width="100%"
      gap={2}
      sx={{ borderRadius: "12px" }}
    >

      <CustomSelect
        label={selectLabel}
        value={selectValue}
        bgColor={COLORS.WhiteBackground}
        options={selectOptions}
        onChange={handleSelectChange}
        sx={{
          "& .MuiSelect-root": { borderRadius: "8px" },
        }}
      />

      <CustomTextField
        value={textFieldValue}
        placeholder={textFieldPlaceholder}
        multiline
        rows={4}
        fullWidth
        bgColor={COLORS.WhiteBackground}
        onChange={(e) => handleTextFieldChange(e.target.value)}
        sx={{
          "& .MuiInputBase-root": {
            borderRadius: "8px",
          },
        }}
      />
    </Box>
  );
};

export default CustomEmailComponent;
